quoteModule.factory('rateProductCacheService', ['$http','AppSettings','commonRESTCallService', 'erateSessionVarsService','imSessionVarsService','$q',
    function ($http, appSettings, commonRESTCallService, erateSessionVarsSvc,imSessionVarsService,$q) {
        var rateProductCacheService = {};

        //retrieve products response from cache id from API
        rateProductCacheService.getCachedProductsForCacheId = function (productCacheId) {
            var deferred = $q.defer();

            var url = appSettings.startSPANVehicleProductSvcURL + "/RetrieveCachedEligibleProducts/" + productCacheId;
            commonRESTCallService.getFromServer(url)
                .success(function (data, status) {
                    deferred.resolve(data);
                })
                .error(function (data, status) {
                    deferred.reject(status + ' ' + data);
                });

            return deferred.promise;
        }

        //retrieve products response from cache id from API
        rateProductCacheService.getCachedRatesForCacheId = function (rateCacheId) {
            var deferred = $q.defer();

            var url = appSettings.startSPANVehicleRateSvcURL + "/RetrieveCachedProductRates/" + rateCacheId;
            commonRESTCallService.getFromServer(url)
                .success(function (data, status) {
                    deferred.resolve(data);
                })
                .error(function (data, status) {
                    deferred.reject(status + ' ' + data);
                });

            return deferred.promise;
        }

        return rateProductCacheService;
    }]);
